module.exports = __webpack_public_path__ + "static/media/67.63e9f071.png";